export function isRedirectedFromReview () {
    return (localStorage.getItem("navto")!=='review')
}